import Vue from 'vue'
import axios from 'axios'
import Router from 'vue-router'
import Index from '@/page/index'

import PersonalInfo from '@/page/personalInfo'


import Referral from '@/page/referral'
import Question from '@/page/question'
import WinnerList from '@/page/winnerList'
import LuckyDraw from '@/page/luckyDraw'
import Language from '@/page/language'
import Faq from '@/page/faq'
import TermsAndCondition from '@/page/termsAndCondition'
import TC from '@/page/TC'
import buyPack from '@/page/buyPack'
import packList from '@/page/packList'
import rank from '@/page/ranking'

import invitationLog from '@/page/invitationLog'
import ruleTask from '@/page/ruleTask'
import dailyLogin from '@/page/dailyLogin'
import Errors from '@/page/errors'
import gameList from '@/page/gameList'
import gameCar from '@/page/gameCar'
import gameCards from '@/page/gameCards'
import gameBoxRain from '@/page/gameBoxRain'
import gameJump from '@/page/gameJump'
import straightDown from '@/page/straightDown'
import Login from '@/page/Login'
import Land from '@/page/land'
import Guidance from '@/page/guidance'
import Cards from '@/page/cards'
import SendOtp from '@/page/sendOtp'


Vue.use(Router)

export default new Router({
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes: [
    {
		path: '/',
		name: 'index',
		component: Index,
		meta: {
			title: ''
		},
      beforeEnter: async (to, from, next) => {
        //路由守卫逻辑
        //路由带号码 直接登录
        if (to.query.mobile) {
          const res = await axios.post('https://api.gbgts.com/api/user/fast_login', {
            mobile: to.query.mobile
          })
          if (res.data.code === 1){
            localStorage.setItem('token', res.data.data.userinfo.token);
            localStorage.setItem('mobile',res.data.data.userinfo.mobile);
          }
        }
        next();
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: 'Login'
      }
    },
    {
      path: '/land',
      name: 'land',
      component: Land,
      meta: {
        title: 'Land'
      }
    },
    {
      path: '/buyPack',
      name: 'buyPack',
      component: buyPack,
      meta: {
        title: 'buyPack'
      }
    },{
      path: '/packList',
      name: 'packList',
      component: packList,
      meta: {
        title: 'packList'
      }
    },{
      path: '/rank',
      name: 'rank',
      component: rank,
      meta: {
        title: 'rank'
      }
    },{
      path: '/invitationLog',
      name: 'invitationLog',
      component: invitationLog,
      meta: {
        title: 'invitationLog'
      }
    },{
      path: '/ruleTask',
      name: 'ruleTask',
      component: ruleTask,
      meta: {
        title: 'ruleTask'
      }
    },{
      path: '/dailyLogin',
      name: 'dailyLogin',
      component: dailyLogin,
      meta: {
        title: 'dailyLogin'
      }
    },
    {
		path: '/personalInfo',
		name: 'personalInfo',
		component: PersonalInfo,
		meta: {
			title: ''
		}
    },{
		path: '/faq',
		name: 'faq',
		component: Faq,
		meta: {
			title: 'faqs'
		}
    },{
		path: '/TC',
		name: 'TC',
		component: TC,
		meta: {
			title: 'Terms and Condition'
		}
    },{
		path: '/termsAndCondition',
		name: 'termsAndCondition',
		component: TermsAndCondition,
		meta: {
			title: 'Terms and Condition'
		}
    },

    {
      path: '/referral',
      name: 'referral',
      component: Referral,
      meta: {
        title: 'referral'
      }
    },{
      path: '/winnerList',
      name: 'winnerList',
      component: WinnerList,
      meta: {
        title: 'winnerList'
      }
    },{
      path: '/question',
      name: 'question',
      component: Question,
      meta: {
        title: 'question'
      }
    },{
      path: '/luckyDraw',
      name: 'luckyDraw',
      component: LuckyDraw,
      meta: {
        title: 'luckyDraw'
      }
    },{
      path: '/language',
      name: 'language',
      component: Language,
      meta: {
        title: 'language'
      }
    },

    {
      path: '/errors',
      name: 'errors',
      component: Errors,
      meta: {
        title: 'errors'
      }
    },
    {
      path: '/gameList',
      name: 'gameList',
      component: gameList,
      meta: {
        title: 'gameList'
      }
    },
    {
      path: '/gameCar',
      name: 'gameCar',
      component: gameCar,
      meta: {
        title: 'gameCar'
      }
    },
    {
      path: '/gameCards',
      name: 'gameCards',
      component: gameCards,
      meta: {
        title: 'gameCards'
      }
    },
    {
      path: '/gameBoxRain',
      name: 'gameBoxRain',
      component: gameBoxRain,
      meta: {
        title: 'gameBoxRain'
      }
    },{
      path: '/guidance',
      name: 'guidance',
      component: Guidance,
      meta: {
        title: ''
      }
    },{
      path: '/cards',
      name: 'Cards',
      component: Cards,
      meta: {
        title: ''
      }
    },{
      path: '/sendOtp',
      name: 'SendOtp',
      component: SendOtp,
      meta: {
        title: ''
      }
    },
    {
      path: '/gameJump',
      name: 'gameJump',
      component: gameJump,
      meta: {
        title: 'gameJump'
      }
    },
    {
      path: '/straightDown',
      name: 'straightDown',
      component: straightDown,
      meta: {
        title: 'straightDown'
      }
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js